import {
  ExternalLinkIcon, HeartIconFill,
  HeartIconOutline,
  ThreeDotsHorizontalIcon, TickIcon, TrashIcon,
} from '../../../icons/Icons';
import Modal from '../../cmp/Modal';
import ProductCommissionsTableNew
  from '../commissions/ProductCommissionsTableNew';
import RefLinkMaker from '../cmp/RefLinkMaker';
import {
  facebookShare,
  openShareWindow,
  pinterestShare, randomString,
  twitterShare,
  whatsAppShare,
} from '../../../tools/func';
import CopyButton from '../../cmp/CopyButton';
import {useCallback, useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import UncontrolledDropdown from 'reactstrap/lib/UncontrolledDropdown';
import DropdownMenu from 'reactstrap/lib/DropdownMenu';
import DropdownItem from 'reactstrap/lib/DropdownItem';
import DropdownToggle from 'reactstrap/lib/DropdownToggle';
import useLinks from './useLinks';
import FormGroup from '../../cmp/form/FormGroup';
import create from 'zustand'
import {del, get, post} from '../../../api';
import useToggle from '../../cmp/hooks/useToggle';
import Button from '../../auth/components/Button';
import Input from '../../cmp/form/Input';

function ProductLinksSection(){
  const {show_site_stripe, website, ref_code, aff_show_product_commissions} = useSelector(useCallback((state)=>{
    const {show_site_stripe, website, ref_code, aff_show_product_commissions} = state.settings;
    return {
      show_site_stripe, website, ref_code, aff_show_product_commissions
    }
  },[]))
  const w = useMemo(()=>{
    return website.startsWith('http') ? website : `https://${website}`;
  },[website])
  const [modalVisible, toggleModalVisible] = useState(false)

  return (
      <>
        <div className={'row justify-content-between'}>
          <div className={'col'}>
            <h3><FormattedMessage id={'productLinks'}/>
              {
                show_site_stripe ?
                    <a href={`${w}/?toolbar=${ref_code}`}
                       className={"ml-2 p-2"}
                       target={"_blank"} rel={"noopener nofollow"}>
                      <ExternalLinkIcon/>
                    </a> : null
              }
            </h3>
          </div>
          {
              aff_show_product_commissions &&
              <div className={'col-auto'}>
                <button className="btn btn-light" onClick={()=>toggleModalVisible(true)}>
                  <FormattedMessage id={'Commissions'}/>
                </button>
                <Modal visible={modalVisible} onClose={()=>toggleModalVisible(false)}
                       title={<FormattedMessage id={'Product Commissions'}/>}>
                  <ProductCommissionsTableNew />
                </Modal>
              </div>
          }
        </div>
        <FormattedMessage tagName={"p"} id={'productLinkSubtitle'}/>
        <RefLinkMaker />
        <p className={'text-muted text-center'}>
          <FormattedMessage id={'productLinkDescription'}/>
        </p>
        <LinkBox />
        <div className={'my-2 py-2'}>
          <hr/>
        </div>
      </>
  )
}

function LinkBox(){
  const [loading, setLoading] = useState(false);
  const loadCategories = useLinkCategories(useCallback((state)=>state.getData,[]))
  const categories = useLinkCategories(useCallback((state)=>state.categories,[]))
  const [loadLinks, data] = useLinks(useCallback((state)=>[state.loadLinks, state.links], []))
  useEffect(()=>{
    setLoading(true)
    loadCategories()
    loadLinks().then(()=>{
      setLoading(false)
    })
  },[loadCategories, loadLinks])
  const shouldShowFavoriteUrl = useMemo(()=>{
    return data && data.some((i)=>i.isFavorite)
  },[data])
  if(loading) return null
  if(data.length === 0) return null;

  return <>
    <div className="d-flex align-items-center justify-content-between">
      <div className={"d-flex align-items-center"}>
        <h4><FormattedMessage id={"History"}/></h4>
          <span className="ml-2">
            <RenderExternalHistory />
          </span>
      </div>
      <WishlistManagementModal />
    </div>
    <div className={"row flex-wrap"}>
      {
        data.map((item)=>{
          return <div key={item.url} className={"col-md-4 col-sm-6 mb-2"}>
            <div className="card">
              {
                  item.image &&
                  <img alt={item.title} src={item.image} loading={"lazy"} style={{width: '100%', height: 200, objectFit: 'cover'}}/>
              }
              <div style={{position: 'absolute', right:0, top:0}}>
                {
                  categories.length > 0 ?<>
                  <AddToListModal id={item.id} />
                  </> : <FavoriteBtn id={item.id} isFavorite={item.isFavorite} />
                }
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>{item.title}</div>
                  <ShareDropdown id={item.id} link={item.url} />
                </div>
                <small className={"text-muted"}>{item.url}</small>
              </div>
            </div>
          </div>
        })
      }
    </div>
  </>
}

function WishlistManagementModal(){
  const [partner_portal_subdomain, ref_code] = useSelector(useCallback((state)=>[state.settings.partner_portal_subdomain, state.settings.ref_code],[]))
  const [visible, toggle] = useToggle(false)
  const [categories, categoryItems, del] = useLinkCategories((state)=>[state.categories, state.categoryItems, state.deleteCategory])
  const [showAddCollection, toggleAddCollection] = useToggle(false)
  const deleteCategory = useCallback((id)=>{
    return ()=>del(id)
  },[del])
  return <>
    <button className={"btn btn-link"} onClick={toggle}>
      Manage collections
    </button>
    <Modal visible={visible} onClose={toggle} title={"Manage collections"}>
      {
        categories.map((item)=>{
          const link = `https://${partner_portal_subdomain}/r/${ref_code}?category=${item.slug}`;
          return <li className={"list-group-item d-flex align-items-center justify-content-between"}>
            <div>
              <CopyButton text={link} title={item.name}/>
            </div>
            <div>
              <button onClick={deleteCategory(item._id)} className={"btn btn-link text-danger"}><TrashIcon /></button>
            </div>
          </li>
        })
      }
      {
        showAddCollection ? <>
        {
          categories.length > 0 ?<hr/> : null
        }
            <NewCollection onClose={toggleAddCollection}/>
            </>
            : null
      }
      <div className="text-center">
        <button className="btn btn-link" onClick={toggleAddCollection}>New collection</button>
      </div>
    </Modal>
  </>
}

const useLinkCategories = create((set)=>{
  return {
    categories:[],
    categoryItems:[],
    getData:()=>{
      return get('/linkbox/categories').then((data)=>{
        set({
          categories: data.categories,
          categoryItems: data.categoryItems,
        })
      })
    },
    addCategory:(name, slug)=>{
      return post('/linkbox/categories',{
        name, slug: randomString(),
      }).then((data)=>{
        set({
          categories: data.categories,
          categoryItems: data.categoryItems,
        })
      })
    },
    deleteCategory:(id)=>{
      return del('/linkbox/categories/'+id).then((data)=>{
        set({
          categories: data.categories,
          categoryItems: data.categoryItems,
        })
      })
    },
    toggleLinkCategory:(link_id, category_id)=>{
      post('/linkbox/categories/toggle_link',{
        link_id,
        category_id
      }).then((data)=>{
        set({
          categories: data.categories,
          categoryItems: data.categoryItems,
        })
      })
    }

  }
})

function NewCollection({onClose}){
  const [name, setName] = useState('')
  const [loading, setLoading] = useState(false)
  const addCategory = useLinkCategories((state)=>state.addCategory)
  const submit = useCallback((e)=>{
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    setLoading(true)
    addCategory(name).then(()=>{
      onClose(e)
      setLoading(false)
    })
  },[addCategory, name, onClose])
  return <form onSubmit={submit}>
    <FormGroup label={"New collection"}>
      <Input value={name} onChange={setName} type="text" />
    </FormGroup>
    <Button loading={loading} type={"submit"} className="btn btn-primary" onClick={submit} title={"Submit"}/>
  </form>
}

const externalLinkReducer = (state)=>[state.settings.ref_code, state.settings.partner_portal_subdomain];

function RenderExternalHistory(){
  const [ref_code, partner_portal_subdomain] = useSelector(externalLinkReducer)
  return <>
    <a target={"_blank"} rel={"noopener noreferrer nofollow"} href={`https://${partner_portal_subdomain}/r/${ref_code}`}><ExternalLinkIcon /></a>
  </>
}

function FavoriteBtn({id, isFavorite}){
  const patchLinks = useLinks(useCallback((state)=>state.patchLinks,[]))
  const toggleFavorite = useCallback(()=>{
    return patchLinks(id, !isFavorite)
  },[id, isFavorite, patchLinks])

  return <button className={"btn"} onClick={toggleFavorite}>
    {
      isFavorite ? <HeartIconFill style={{color:'#e84393', fontSize:18}}/> :  <HeartIconOutline style={{fontSize:18}} />
    }
  </button>
}

function AddToListModal({id}){
  const [categories, categoryItems, toggleLinkCategory] = useLinkCategories((state)=>[state.categories, state.categoryItems, state.toggleLinkCategory])
  const [visible, toggle] = useToggle()
  const toggleInCategory = useCallback((_id)=>{
      return ()=>{
        toggleLinkCategory(id, _id)
      }
  },[id, toggleLinkCategory])
  return <>
    <button className={"btn"} onClick={toggle}>
       <HeartIconOutline style={{fontSize:18}} />
    </button>
    <Modal visible={visible} title={"Add to collection"} onClose={toggle}>
      <ul className="list-group">
      {
        categories.map(({_id, name})=>{
          const isInCategory = categoryItems.find(({link_id, category_id})=>link_id == id && category_id == _id)
          return <button className={"list-group-item d-flex align-items-center justify-content-between list-group-item-action"} key={String(_id)}
                     onClick={toggleInCategory(_id)}>{name} {isInCategory ? <TickIcon /> : null }
          </button>
        })
      }
      </ul>
    </Modal>
  </>
}

const delReducer = (state)=>state.deleteLink
function ShareDropdown({id, link}){
  const deleteLink = useLinks(delReducer)
  const shareOnFacebook = () => {
    openShareWindow(facebookShare(link), "facebook", "width=500, height=500")
  }
  const shareOnTwitter = () => {
    openShareWindow(twitterShare(link), 'twitter', 'width=600,height=300');
  }
  const shareOnPinterest = () => {
    openShareWindow(pinterestShare(link, '', ''), "pinterest", "width=600,height=300")
  }
  const shareOnWhatsApp = () => {
    window.open(whatsAppShare(link))
  }
  const onDelete = ()=>{
    deleteLink(id).then(()=>{
      console.log('deleted')
    })
  }

  return <UncontrolledDropdown>
    <DropdownToggle color={"transparent"} className={"p-0"}>
      <span><ThreeDotsHorizontalIcon/></span>
    </DropdownToggle>
    <DropdownMenu>
      <CopyButton className={"dropdown-item text-dark"}
                  text={link}
                  title={"Copy Link"}/>
      <DropdownItem header>
        <FormattedMessage id={"Share"}/>
      </DropdownItem>
      <DDItem onClick={shareOnFacebook} title={"Facebook"} src={"/images/facebook.svg"}/>
      <DDItem onClick={shareOnTwitter} title={"Twitter"} src={"/images/twitter.svg"}/>
      <DDItem onClick={shareOnPinterest} title={"Pinterest"}
              src={"/images/pinterest.svg"}/>
      <DDItem onClick={shareOnWhatsApp} title={"WhatsApp"} src={"/images/whatsapp.svg"}/>
      <DropdownItem header>
        <FormattedMessage id={"Options"}/>
      </DropdownItem>
      <DropdownItem onClick={onDelete}><span className={"text-danger btn"}><FormattedMessage id={"Delete"} /></span></DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
}

function DDItem({onClick, title, src}) {
  return <DropdownItem onClick={onClick}>
    <SocialIcon title={title} src={src}/>
  </DropdownItem>
}
function SocialIcon({src, title}) {
  return <div className={"d-flex align-items-center"}>
    <img alt={title} src={src} width={18}/>
    <span className={"ml-2"}>{title}</span>
  </div>
}


export default ProductLinksSection
